import { FC, ReactNode } from 'react';
import { css } from '@emotion/react';
import { colors, spacing, fontStyles } from '../../styles';

interface Props {
  label: string;
  badge?: string;
  children: ReactNode;
}

const InlineSettingRow: FC<Props> = ({ label, badge, children }) => {
  return (
    <div
      css={css`
        margin-bottom: ${spacing.deci};
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          gap: ${spacing.milli};
          margin-bottom: ${spacing.milli};
        `}
      >
        <span
          css={css`
            ${fontStyles.mouse};
            color: ${colors.silver};

            html[data-theme='dark'] & {
              color: ${colors.cloud};
            }
          `}
        >
          {label}
        </span>
        {badge && (
          <span
            css={css`
              ${fontStyles.flea};
              background-color: ${colors.petrolBlue};
              color: ${colors.sugar};
              padding: 2px 6px;
              border-radius: 4px;
              font-weight: 500;

              html[data-theme='dark'] & {
                background-color: ${colors.skyBlue};
                color: ${colors.liquorice};
              }
            `}
          >
            {badge}
          </span>
        )}
      </div>
      {children}
    </div>
  );
};

export default InlineSettingRow;
